import BaseEnum from "./base_enum.js.jsx";
import I18n from "../base/i18n.js";

class YesNoEnumDesc extends BaseEnum {

  name() {
    return "yes_no";
  }

  rawValues() {
    return ["yes", "no"];
  }

  values() {
    let result = {};
    this.rawValues().forEach((rawValue) => {
      result[rawValue] = {
        value: rawValue,
        label: I18n.t(`shared.${rawValue}_text`)
      }
    });
    return result;
  }

}

const YesNoEnum = new YesNoEnumDesc();
export default YesNoEnum;